import { Box, Typography, useTheme } from "@mui/material";

interface ContactCardProps {
  name: string;
  email: string;
  phone: string;
  position: string;
  address: string;
}

const ContactCard: React.FC<ContactCardProps> = ({
  name,
  email,
  phone,
  position,
  address,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "16px",
        borderRadius: "4px",
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          marginBottom: "12px",
        }}
      >
        {name}
      </Typography>

      <Typography variant="body2">{position}</Typography>

      <Typography variant="body2">{phone}</Typography>

      <Typography variant="body2">{email}</Typography>
    </Box>
  );
};

export default ContactCard;
export type { ContactCardProps };
